import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "item-center flex flex-col justify-center p-12" }
const _hoisted_2 = { class: "fixed top-0 left-0 right-0" }
const _hoisted_3 = { class: "hover:bg-blue flex h-24 w-full items-center justify-center rounded-lg bg-blue-300 text-2xl font-semibold tracking-wide text-black hover:text-white" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("写真を撮影して"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("バスに送る")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "mt-2 font-semibold" }, [
  /*#__PURE__*/_createTextVNode("撮影済の写真から"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("選んでバスに送る")
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", { class: "mt-5 flex h-20 w-full items-center justify-center rounded-lg bg-pink-300 text-2xl font-semibold tracking-wide hover:bg-pink-400 hover:text-white" }, [
  /*#__PURE__*/_createTextVNode(" バスに送った"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("写真をみる ")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", { class: "mt-10 h-20 w-full rounded-md bg-sky-400 text-2xl font-medium font-semibold text-black hover:bg-sky-500 hover:text-white" }, " お問い合わせ ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PreviewModal = _resolveComponent("PreviewModal")!
  const _component_HintModal = _resolveComponent("HintModal")!
  const _component_Toast = _resolveComponent("Toast")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PreviewModal, {
      open: _ctx.previewOpen,
      showModal: _ctx.previewToggle,
      photoImage: _ctx.captureImage,
      user: _ctx.user,
      showToast: _ctx.triggerToast,
      ref: "uploadMessage"
    }, null, 8, ["open", "showModal", "photoImage", "user", "showToast"]),
    _createVNode(_component_HintModal, {
      onSelected: _ctx.onSelected,
      ref: "hintModal"
    }, null, 8, ["onSelected"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_Transition, {
        name: "toast",
        message: _ctx.toastMessage,
        result: _ctx.toastResult
      }, {
        default: _withCtx(() => [
          (_ctx.showToast)
            ? (_openBlock(), _createBlock(_component_Toast, { key: 0 }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["message", "result"])
    ]),
    _createElementVNode("form", {
      onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"])),
      action: "#",
      method: "POST"
    }, [
      _createElementVNode("label", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("input", {
          type: "file",
          class: "hidden",
          accept: "image/*",
          capture: "environment",
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onCaptureImage && _ctx.onCaptureImage(...args))),
          ref: "capture"
        }, null, 544)
      ]),
      _createElementVNode("label", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showHint && _ctx.showHint(...args))),
        class: "mt-5 flex h-24 w-full items-center justify-center rounded-lg bg-teal-300 text-2xl font-semibold hover:bg-teal-400 hover:text-white"
      }, _hoisted_6),
      _createElementVNode("input", {
        type: "file",
        accept: "image/*",
        onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args))),
        class: "hidden",
        ref: "pickup"
      }, null, 544),
      _createVNode(_component_router_link, {
        to: `/${_ctx.groupId}/user/photolist`,
        class: "flex w-full items-center justify-center"
      }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }, 8, ["to"]),
      _createVNode(_component_router_link, {
        to: `/${_ctx.groupId}/about`
      }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }, 8, ["to"])
    ], 32)
  ]))
}